module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/logo-ol-ebc-footer-2_d890482.png";